/* Pooja Ragenee theme · pr-size.js: the one size helper (snippets/pr-size-modal.liquid). Port of mockup AP.size.recommend + sizeChart.
   PR.size.open({ sizes: ['30D',..] | '30D,32D', tab: 'find'|'chart', pick: true, name: 'Full Coverage D Cup Bra' }) -> emits pr:size-pick { size }
   PR.size.recommend(underbust, bust, 'in'|'cm', sizes?) -> { ok, size, raw, exact, fitsThis, note, error }
   Trigger: <a href="/pages/bra-size-guide-1" data-ap-size-open data-sizes="30D,32D" data-tab="chart" data-pick data-name="..."> */
(function (w, d) {
  'use strict';
  var PR = w.PR, $ = PR.$, $$ = PR.$$, esc = PR.esc, parse = PR.size.parse, CUPS = PR.size.cups;
  function t(k, v) { return PR.t('size.' + k, v); }
  function braStr(b, ci) { return b + CUPS[ci]; }
  function made() { return ((w.PR_DATA || {}).braSizes || []).filter(parse); }
  function range(sizes) { var s = PR.size.sort(sizes || []); return s.length > 1 ? s[0] + '–' + s[s.length - 1] : (s[0] || ''); }
  function list(x) { return (Array.isArray(x) ? x : String(x || '').split(',')).map(function (s) { return String(s).trim(); }).filter(Boolean); }

  PR.size.recommend = function (underbust, bust, unit, sizes) {
    var ub = Number(underbust), bu = Number(bust);
    if (unit === 'cm') { ub /= 2.54; bu /= 2.54; }
    if (!(ub > 0) || !(bu > 0)) return { ok: false, error: t('err_both') };
    if (ub < 22 || ub > 50) return { ok: false, error: t(unit === 'cm' ? 'err_ub_cm' : 'err_ub_in') };
    if (bu <= ub) return { ok: false, error: t('err_bust') };
    sizes = list(sizes);
    var cat = made(); if (!cat.length) cat = sizes.filter(parse);
    var band = Math.round(ub); if (band % 2) band += 1;
    var ci = PR.clamp(Math.floor(bu - band + 0.5), 0, CUPS.length - 1);
    var raw = braStr(band, ci), b = PR.clamp(band, 28, 44), c = ci, up = 0, down = 0, why = [];
    if (b !== band) why.push(t('why_band'));
    while (c > 4 && b + 2 <= 44 && up < 2) { b += 2; c--; up++; }
    var capped = c > 4; if (capped) c = 4;
    while (c < 2 && b - 2 >= 28 && down < 2) { b -= 2; c++; down++; }
    var floored = c < 2; if (floored) c = 2;
    if (up || capped) why.push(t(capped ? 'why_cap' : 'why_up', { size: braStr(b, c) }));
    if (down || floored) why.push(t(floored ? 'why_floor' : 'why_down', { size: braStr(b, c) }));
    var size = braStr(b, c);
    if (cat.length && cat.indexOf(size) < 0) {   // nearest size we make (cup counts double: fit lives in the cup)
      var best = size, bestD = 1e9;
      cat.forEach(function (s) { var x = parse(s); var dd = Math.abs(x.band - b) / 2 + Math.abs(x.ci - c) * 2; if (dd < bestD) { bestD = dd; best = s; } });
      size = best; why.push(t('why_near', { size: size }));
    }
    var fitsThis = !sizes.length || sizes.indexOf(size) >= 0;
    var note = size === raw ? t('note_exact', { size: raw }) : (t('note_measure', { size: raw }) + ' ' + why.join(' ')).trim();
    if (!fitsThis) note += ' ' + t('not_this', { range: range(sizes), size: size });
    else if (size !== raw) note += ' ' + t('exchange');
    return { ok: true, size: size, raw: raw, exact: size === raw, fitsThis: fitsThis, note: note };
  };

  var dlg, ctx = {}, unit = 'in', tab = 'find';
  function setUnit(u) {
    unit = u;
    $$('[data-unit]', dlg).forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-unit') === u)); });
    $$('[data-unit-label]', dlg).forEach(function (x) { x.textContent = t(u === 'cm' ? 'unit_cm' : 'unit_in') || u; });
    if (tab === 'chart') chart();
  }
  function setTab(x) {
    tab = x;
    $$('[data-size-tab]', dlg).forEach(function (b) { var on = b.getAttribute('data-size-tab') === x; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
    $('#ap-size-find', dlg).hidden = x !== 'find'; $('#ap-size-chart', dlg).hidden = x !== 'chart';
    $('#ap-size-title', dlg).textContent = t(x === 'chart' ? 'title_chart' : 'title_find');
    if (x === 'chart') chart();
  }
  function chart() {
    var box = $('#ap-size-chart', dlg), sz = ctx.chartSizes.map(parse).filter(Boolean), bands = [], cups = [], cm = unit === 'cm';
    sz.forEach(function (x) { if (bands.indexOf(x.band) < 0) bands.push(x.band); if (cups.indexOf(x.ci) < 0) cups.push(x.ci); });
    bands.sort(function (a, b) { return a - b; }); cups.sort(function (a, b) { return a - b; });
    function isMade(bd, ci) { return sz.some(function (x) { return x.band === bd && x.ci === ci; }); }
    function v(inch) { return cm ? Math.round(inch * 2.54) : inch; }
    var cap = t(cm ? 'caption_cm' : 'caption_in', { range: range(ctx.chartSizes) });
    box.innerHTML =
      '<div class="ap-seg" role="group" aria-label="' + esc(t('unit')) + '"><button type="button" data-unit="in" aria-pressed="' + !cm + '">' + esc(t('inches')) + '</button><button type="button" data-unit="cm" aria-pressed="' + cm + '">' + esc(t('centimetres')) + '</button></div>' +
      '<table class="ap-chart"><caption>' + esc((ctx.name ? ctx.name + ', ' : '') + cap) + '</caption><thead><tr><th scope="col">' + esc(t('band')) + '</th><th scope="col">' + esc(t('underbust')) + '</th>' +
      cups.map(function (ci) { return '<th scope="col">' + esc(t('cup_bust', { cup: CUPS[ci] })) + '</th>'; }).join('') + '</tr></thead><tbody>' +
      bands.map(function (bd) {
        return '<tr><th scope="row">' + bd + '</th><td>' + v(bd - 1) + '–' + v(bd) + '</td>' +
          cups.map(function (ci) { return isMade(bd, ci) ? '<td>' + v(bd + ci) + '</td>' : '<td class="is-none" aria-label="' + esc(t('not_made')) + '">–</td>'; }).join('') + '</tr>';
      }).join('') + '</tbody></table>' +
      '<p class="ap-chart__note">' + t('chart_note_html') + '</p>' +
      '<p class="ap-chart__go"><button type="button" class="ap-quiet-link" data-size-go>' + esc(t('chart_go')) + '</button></p>';
  }
  function wire() {
    dlg = $('#ap-size-modal'); if (!dlg || dlg._prSize) return; dlg._prSize = true;
    PR.modal.wire(dlg);
    var g = $('[data-pr-size-guide]', dlg); if (g && PR.cfg.links.sizeGuide) g.setAttribute('href', PR.cfg.links.sizeGuide);
    dlg.addEventListener('click', function (e) {
      var u = e.target.closest('[data-unit]'); if (u) { setUnit(u.getAttribute('data-unit')); return; }
      var tb = e.target.closest('[data-size-tab]'); if (tb) { setTab(tb.getAttribute('data-size-tab')); return; }
      if (e.target.closest('[data-size-go]')) { setTab('find'); var i = $('#ap-fit-ub', dlg); if (i) i.focus(); }
    });
    $('[data-size-tabs]', dlg).addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault(); setTab(tab === 'find' ? 'chart' : 'find'); $('[data-size-tab="' + tab + '"]', dlg).focus();
    });
    $('[data-fit-form]', dlg).addEventListener('submit', function (e) {
      e.preventDefault();
      var r = PR.size.recommend($('#ap-fit-ub', dlg).value, $('#ap-fit-bu', dlg).value, unit, ctx.sizes);
      $('[data-fit-err]', dlg).textContent = r.ok ? '' : r.error;
      var box = $('[data-fit-result]', dlg); box.hidden = !r.ok;
      if (!r.ok) return;
      $('[data-fit-size]', dlg).textContent = r.size;
      $('[data-fit-note]', dlg).textContent = r.note;
      var use = $('[data-fit-use]', dlg);
      use.hidden = !ctx.pick || !r.fitsThis;
      use.textContent = t('choose', { size: r.size });
      use.onclick = function () { PR.modal.close(dlg); PR.emit('size-pick', { size: r.size, result: r }); if (typeof ctx.onPick === 'function') ctx.onPick(r.size, r); };
    });
  }
  PR.size.open = function (o) {
    wire(); if (!dlg) return null;
    o = o || {};
    var sizes = list(o.sizes);
    ctx = { sizes: sizes, pick: !!o.pick, onPick: o.onPick, name: o.name || '' };
    ctx.chartSizes = (sizes.length ? sizes : made()).filter(parse);
    var hasChart = ctx.chartSizes.length > 0;
    /* "Find it in 30 seconds" opens ONE simple form (mockup): tabs + guide link only when opened as the size guide */
    var asGuide = hasChart && o.tab === 'chart';
    $('[data-size-tabs]', dlg).hidden = !asGuide;
    var gl = $('[data-pr-size-guide]', dlg); if (gl && gl.parentNode) gl.parentNode.hidden = !asGuide;
    $('[data-fit-result]', dlg).hidden = true; $('[data-fit-err]', dlg).textContent = '';
    setTab(hasChart && o.tab === 'chart' ? 'chart' : 'find');
    PR.modal.open(dlg, o.opener);
    setTimeout(function () {
      var i = $('#ap-fit-ub', dlg);
      if (tab === 'find' && i && w.matchMedia && w.matchMedia('(hover: hover)').matches) i.focus(); else $('#ap-size-title', dlg).focus({ preventScroll: true });
    }, 0);
    return dlg;
  };
  PR.ready(function () {
    wire();
    d.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ap-size-open]'); if (!a || !dlg) return;
      e.preventDefault();
      PR.size.open({ sizes: a.getAttribute('data-sizes') || '', tab: a.getAttribute('data-tab') || 'find', pick: a.hasAttribute('data-pick'), name: a.getAttribute('data-name') || '', opener: a });
    });
  });
})(window, document);